module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Medium.80963626.woff2";